"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_2 = __importStar(require("react"));
var api_1 = require("@react-google-maps/api");
var containerStyle = {
    width: '100%',
    height: '400px'
};
var GMap = /** @class */ (function (_super) {
    __extends(GMap, _super);
    function GMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GMap.prototype.checkFilters = function (filters, tech) {
        var pass = true;
        if (filters.product != "" &&
            filters.product != "none" &&
            !tech.Products.includes(filters.product)) {
            pass = false;
        }
        if (filters.region != "" &&
            filters.region != "none" &&
            !tech.Region.includes(filters.region)) {
            pass = false;
        }
        return pass;
    };
    GMap.prototype.render = function () {
        var _this = this;
        return (react_2.default.createElement(api_1.LoadScript, { googleMapsApiKey: "AIzaSyCrQkLHt22A920N-JrjzXYWNASKZTUwVQo" },
            react_2.default.createElement(api_1.GoogleMap, { mapContainerStyle: containerStyle, center: this.props.geolocationCenter, zoom: this.props.geolocationZoom }, this.props.techs.map(function (tech, index) {
                if (_this.checkFilters(_this.props.filters, tech)) {
                    return (react_2.default.createElement("div", { key: index },
                        react_2.default.createElement(api_1.Marker, { position: {
                                lat: tech.Location.lat,
                                lng: tech.Location.lng,
                            }, onClick: function () { return _this.props.onMapMarkerClick(index); } }, _this.props.openInfoIndex == index && (react_2.default.createElement(api_1.InfoWindow, { onCloseClick: function () { return _this.props.onMapMarkerClick(-1); } },
                            react_2.default.createElement("div", null,
                                react_2.default.createElement("p", null,
                                    "Company: ",
                                    tech.Company,
                                    " "),
                                react_2.default.createElement("p", null,
                                    "Phone:",
                                    " ",
                                    react_2.default.createElement("a", { href: "tel:".concat(tech.Phone) },
                                        " ",
                                        tech.Phone),
                                    " ")))))));
                }
                else {
                    return react_2.default.createElement("div", { key: index });
                }
            }))));
    };
    return GMap;
}(react_2.Component));
exports.default = (0, react_1.memo)(GMap);
